<script setup lang="ts">
import { onMounted, ref } from 'vue'
import {
  fetchNoticeCount,
  fetchPanMajorbioData,
  isShowSubscribe,
  fetchHomeNoticeList,
  fetchContractRead
} from '@/api/common'
import originSureDialog from '@/components/home/originSureDialog.vue'
import followWechatDialog from '@/components/home/followWechatDialog.vue'
import contractSureDialog from '@/components/home/contractSureDialog.vue'
import noticeDialog from '@/components/home/noticeDialog.vue'
import common from '@/utils/common'
import { useUserStore } from '@/store/modules/user'
import { storeToRefs } from 'pinia'
import Cookies from 'js-cookie'
import { fetchReportErrorLog } from '@/api/projectCenter/common'

// 数据初始化
const originSureDialogRef = ref(null)
const contractSureDialogRef = ref(null)
const followWechatDialogRef = ref(null)
const noticeDialogRef = ref(null)
let noticeArr = ref<any>([]) // 公告列表
let timer: any = null

// 区分美吉、桑格
let link: any =
  document.querySelector("link[rel*='icon']") || document.createElement('link')
link.type = 'image/x-icon'
link.rel = 'shortcut icon'

let descriptionMeta: any = document.querySelector('meta[name="description"]')
if (!descriptionMeta) {
  descriptionMeta = document.createElement('meta')
  descriptionMeta.name = 'description'
  document.head.appendChild(descriptionMeta)
}
let keywordsMeta: any = document.querySelector('meta[name="keywords"]')
if (!keywordsMeta) {
  keywordsMeta = document.createElement('meta')
  keywordsMeta.name = 'keywords'
  document.head.appendChild(keywordsMeta)
}
if (common.getWebName() === 'mj') {
  document.title = '美吉科服网 - 美吉生物一站式科研服务平台' // title
  link.href = '/favicon.ico' // icon
  descriptionMeta.content =
    '上海美吉生物医药科技有限公司专注于新一代DNA高通量测序技术的应用和推广、生物信息分析、临床诊断试剂盒研发和转化医学研究，是上海张江高科技园区、张江药谷重点支持企业，华东师范大学战略合作单位。目前，美吉生物在上海、北京、广州三个一线城市建立了实验基地，销售网络遍布全国各地。'
  keywordsMeta.content =
    '美吉生物、二代测序、三代测序、质谱、转录组、微生态、单细胞、空间多组学、基因组'
} else if (common.getWebName() === 'sg') {
  document.title = '桑格科服网 - 桑格信息一站式科研服务平台'
  link.href = '/sanger_favicon.ico'
  descriptionMeta.content =
    '上海桑格信息技术有限公司专注于新一代DNA高通量测序技术的应用和推广、生物信息分析、临床诊断试剂盒研发和转化医学研究，是上海张江高科技园区、张江药谷重点支持企业，华东师范大学战略合作单位。目前，桑格信息在上海、北京、广州三个一线城市建立了实验基地，销售网络遍布全国各地。'
  keywordsMeta.content =
    '桑格信息、二代测序、三代测序、质谱、转录组、微生态、单细胞、空间多组学、基因组'
}

// pinia使用
const userStore = useUserStore()
const { userInfo, contractStr, hasUnconfirmed } = storeToRefs(userStore)

// 提醒数量（我的事项、项目总览）
const getNoticeCount = () => {
  fetchNoticeCount({}).then((res: any) => {
    let { c, d } = res
    if (c === 0) {
      let { notify_no, fx_report_no } = d
      userStore.setCount({
        noticeCount: notify_no,
        projectAllCount: fx_report_no
      })
    }
  })
}

const getChContractRead = () => {
  if (contractStr.value) {
    if (contractSureDialogRef.value) {
      contractSureDialogRef.value.dialogVisible = true
    }
  }
}
const getPanMajorbioData = () => {
  if (hasUnconfirmed.value) {
    if (originSureDialogRef.value) {
      originSureDialogRef.value.dialogVisible = true
    }
  }
}

// 是否显示关注公众号弹窗
const getIsShowSubscribe = () => {
  isShowSubscribe({}).then((res: any) => {
    let { code, data } = res
    if (code === 0) {
      let { is_show } = data
      if (is_show && followWechatDialogRef.value) {
        followWechatDialogRef.value.dialogVisible = true
      }
    }
  })
}

// 是否显示公告弹窗
const getHomeNoticeList = (listData?: any) => {
  noticeArr.value = []
  let readed = []
  fetchHomeNoticeList({}).then((res: any) => {
    let { code, data } = res

    if (code === 0) {
      data.data.map((item: any) => {
        if (listData && listData.length > 0) {
          item.is_read = true
        }
        if (!item.is_read) {
          noticeArr.value.push(item)
        }
        if (item.is_read) {
          readed.push(item)
        }
        console.log(item.notice_id, item.is_read)
      })
      if (noticeArr.value.length > 0 && noticeDialogRef.value) {
        noticeDialogRef.value.dialogVisible = true
        noticeDialogRef.value.editDialog({ noticeArr: noticeArr.value })
      }
      if (readed.length === data.data.length && noticeDialogRef.value) {
        noticeDialogRef.value.dialogVisible = false
      }
    }
  })
}

const reportErrorLog = (params: any) => {
  fetchReportErrorLog(params).then((res: any) => {
    let { code } = res
    if (code === 0) {
      console.log('上报成功')
    }
  })
}
// 生产环境再去做上传错误处理
const NODE_ENV = import.meta.env.VITE_APP_ENV

onMounted(() => {
  if (NODE_ENV === 'local') {
    window.document.documentElement.setAttribute('theme-style', 'sg')
  } else if (NODE_ENV === 'test') {
    window.document.documentElement.setAttribute(
      'theme-style',
      common.getWebName() || 'mj'
    )
  } else if (NODE_ENV === 'production') {
    window.document.documentElement.setAttribute(
      'theme-style',
      common.getWebName() || 'mj'
    )
  }

  // 首次加载清空一些数据
  const isFirstLoad = !sessionStorage.getItem('visited')
  if (isFirstLoad) {
    console.log('首次加载')
    Cookies.remove('panMajorbioVisible')
    Cookies.remove('contractReadVisible')
    console.log('删除cookie1')
    sessionStorage.setItem('visited', 'true') // 标记已访问
    // 免密登录进来的
    sessionStorage.removeItem('defaultAddressTemp')
    localStorage.removeItem('extraContact')
  } else {
    console.log('非首次加载（刷新或返回）')
  }

  let userInfo = common.getCache('user')
  if (userInfo && JSON.stringify(userInfo) !== '{}') {
    // pinia使用
    const userStore = useUserStore()
    common.getCache('vip-token') && userStore.getPendingCount()

    if (window.location.pathname !== '/project-center/download') {
      getNoticeCount()
    }
  }

  // getNoticeCount()
  if (window.location.pathname !== '/project-center/download') {
    getIsShowSubscribe()
    getHomeNoticeList()
  }

  let panMajorbioVisible = Cookies.get('panMajorbioVisible')
  let contractReadVisible = Cookies.get('contractReadVisible')

  if (panMajorbioVisible === null || panMajorbioVisible === undefined) {
    // 第一次加载应用走接口
    getPanMajorbioData()
  } else {
    // 之后都走缓存取值
    if (originSureDialogRef.value) {
      originSureDialogRef.value.dialogVisible = panMajorbioVisible === 'false'
    }
  }

  if (contractReadVisible === null || contractReadVisible === undefined) {
    // 第一次加载应用走接口
    getChContractRead()
  } else {
    // 之后都走缓存取值
    if (contractSureDialogRef.value) {
      contractSureDialogRef.value.dialogVisible = contractReadVisible === '0'
    }
  }

  if (NODE_ENV === 'production' || NODE_ENV === 'local') {
    // 1.前端错误捕获（主要捕捉异步错误（非Promise），开发构建阶段的错误不需要捕获）（无法捕获2）
    // window.onerror = (message, source, lineno, colno, error) => {
    //   let errorStr = JSON.stringify(error, Object.getOwnPropertyNames(error))
    //   let errorObj = JSON.parse(errorStr)
    //   let stack = errorObj['stack']

    //   let params = {}
    //   params.message = message
    //   params.url = window.location.href
    //   params.type = '异步异常onerror'
    //   params.stack = stack
    //   params.userAgent = navigator.userAgent
    //   console.log('捕获的异常类型：异步异常onerror', message)
    //   reportErrorLog(params)
    // }

    // 2. 捕获Promise（无法捕获1）
    window.addEventListener(
      'unhandledrejection',
      (args) => {
        // 参数检查
        if (!args || !args.reason) {
          console.error('unhandledrejection: 参数无效', args)
          return
        }

        // 构建错误日志对象
        let params = {
          message: args.reason.message || '未知错误',
          url: window.location.href,
          type: 'Promise异常',
          stack: args.reason.stack || '无堆栈信息',
          userAgent: navigator.userAgent || '未知用户代理',
          systemType: 'vip',
          urlOrigin: window.location.origin,
          account: common.getCache('user').account_name || '未知'
        }

        console.log('捕获的异常类型：Promise异常', params)

        // 上报错误日志
        // reportErrorLog(params)

        return true
      },
      true
    )

    // 4. 捕获（和1一样）
    window.addEventListener('error', (event) => {
      // 参数检查
      if (!event || !event.message || !event.error) {
        console.error('error event: 参数无效', event)
        return
      }

      // 构建错误日志对象
      let params = {
        message: event.message || '未知错误',
        url: window.location.href,
        type: '非Promise异步异常',
        stack: event.error.stack || '无堆栈信息',
        userAgent: navigator.userAgent || '未知用户代理',
        systemType: 'vip',
        urlOrigin: window.location.origin,
        account: common.getCache('user').account_name || '未知'
      }

      console.log('捕获的异常类型：异步异常error', params)

      // 上报错误日志
      // reportErrorLog(params)

      // reportErrorLog(params).then((res: any) => {
      //   const { code, data } = res
      //   if (code === 0) {
      //     return resolve(data)
      //   }
      // })
    })
  }
})
</script>

<template>
  <router-view />
  <!-- 原始数据未确认的弹窗 -->
  <origin-sure-dialog ref="originSureDialogRef" />

  <!-- 合同立项信息未确认的弹窗 -->
  <contract-sure-dialog
    :contractStr="contractStr"
    ref="contractSureDialogRef"
  />

  <!-- 关注公众号弹窗 -->
  <follow-wechat-dialog ref="followWechatDialogRef" />

  <!-- 公告弹窗 -->
  <notice-dialog ref="noticeDialogRef" @ok="getHomeNoticeList" />
</template>

<style>
#app {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  min-width: 1000px;
}
</style>
